export const LANGUAGES = [
  { label: 'HUN', code: 'hu' },
  { label: 'ENG', code: 'en' },
  { label: 'HRV', code: 'hr' },
];
